import { createAsyncThunk } from '@reduxjs/toolkit'

import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import taListAPI from 'api/ApiActions/TextAnalysis/Contributions'
import taTagsAPI from 'api/ApiActions/TextAnalysis/ContributionTags'

const searchParams = new URLSearchParams(window.location.search)

const LOCATION_PATH = window.location.pathname.split('/')
const PROJECT_ID =
  searchParams.get('project_id') || LOCATION_PATH[LOCATION_PATH.length - 1]
const OWNER_ID = searchParams.get('owner_id')
const OWNER_TYPE = searchParams.get('owner_type')

export const fetchContributions: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>(
  'textAnalysis/getContributions',
  async (payload = {}, { getState, rejectWithValue }) => {
    const { textAnalysis } = getState()
    const { queries, userFilters } = textAnalysis

    const response = await taListAPI.getList({
      ...payload,
      ...queries,
      attributes: {
        'project.id': PROJECT_ID,
        ...(OWNER_ID ? { 'owner.id': OWNER_ID } : {}),
        ...(OWNER_TYPE ? { 'owner.type': OWNER_TYPE } : {}),
        ...userFilters,
      },
    })
    if (response?.status >= 200 && response?.status < 300) {
      return response.data
    } else {
      return rejectWithValue(
        response?.message || 'Failed to fetch information.',
      )
    }
  },
)

export const getSingleContribution: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>(
  'textAnalysis/getSingleContribution',
  async (payload = {}, { rejectWithValue }) => {
    const response = await taListAPI.getList({
      attributes: {
        'project.id': PROJECT_ID,
        ...payload,
      },
    })
    if (response?.status >= 200 && response?.status < 300) {
      return response.data
    } else {
      return rejectWithValue(
        response?.message || 'Failed to fetch information.',
      )
    }
  },
)

export const fetchAllTags: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('textAnalysis/getTags', async (payload = {}, { rejectWithValue }) => {
  const response = await taTagsAPI.getTags({
    ...payload,
    attributes: {
      'project.id': PROJECT_ID,
    },
  })
  if (response?.status >= 200 && response?.status < 300) {
    return response.data
  } else {
    return rejectWithValue(response?.message || 'Failed to fetch tags')
  }
})

export const newContributionTags: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('textAnalysis/createTags', async (payload = {}, { rejectWithValue }) => {
  const response = await taTagsAPI.createTags({
    ...payload,
    attributes: {
      'project.id': PROJECT_ID,
    },
  })
  if (response?.status >= 200 && response?.status < 300) {
    return response.data
  } else {
    return rejectWithValue(response?.message || 'Failed to create tags')
  }
})

export const updateContributionTags: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('textAnalysis/updateTags', async (payload = {}, { rejectWithValue }) => {
  const response = await taTagsAPI.updateTags({
    ...payload,
  })
  if (response?.status >= 200 && response?.status < 300) {
    return response.data
  } else {
    return rejectWithValue(response?.message || 'Failed to update tags')
  }
})

export const bulkTags: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('textAnalysis/bulkUpdateTags', async (payload = {}, { rejectWithValue }) => {
  const response = await taTagsAPI.bulkUpdateTags({
    ...payload,
    attributes: {
      'project.id': PROJECT_ID,
    },
  })
  if (response?.status >= 200 && response?.status < 300) {
    return response.data
  } else {
    return rejectWithValue(
      response?.response?.data?.error_data[0] || 'Failed to bulk update tags',
    )
  }
})
